import { render, staticRenderFns } from "./BudgetIssuesUnclassifiedCampaignsComponent.vue?vue&type=template&id=101332ad&scoped=true"
import script from "./BudgetIssuesUnclassifiedCampaignsComponent.vue?vue&type=script&lang=js"
export * from "./BudgetIssuesUnclassifiedCampaignsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101332ad",
  null
  
)

export default component.exports